/*
 * @Author: wangxiang 
 * @Date: 2019-11-11 13:41:56 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-11-23 18:02:09
 */
import Vue from 'vue';
import TBackground from './plugins/t-background';
import TPicture from './plugins/t-picture';
import Ttext from './plugins/t-text';
import MBottomBar from './plugins/m-bottom-bar';
import MImageBox from './plugins/m-image-box';

export const pluginList = [
  {
    title: '背景',
    component: TBackground,
    visible: true,
    name: TBackground.name
  }, {
    title: '图片',
    component: TPicture,
    visible: true,
    name: TPicture.name
  }, {
    title: '文字',
    component: Ttext,
    visible: true,
    name: Ttext.name
  }, {
    title: '底条',
    component: MBottomBar,
    visible: true,
    name: MBottomBar.name
  }, {
    title: '图片框',
    component: MImageBox,
    visible: true,
    name: MImageBox.name
  }
];

export default {
  data() {
    return { pluginList };
  },
  methods: {
    init() {
      pluginList.forEach(plugin => {
        Vue.component(plugin.name, plugin.component);
      });
    }
  },
  created() {
    this.init();
  }
}



// WEBPACK FOOTER //
// ./src/module/album/load-plugins.js